import { createContext, useReducer } from 'react'
import categoryReducer from './CategoryReducer'

const CategoryContext = createContext()

export const CategoryProvider = ({ children }) => {
  const initialState = {
    categories: [],
    category: {},
    loading: false,
  }

  const [state, dispatch] = useReducer(categoryReducer, initialState)

  return (
    <CategoryContext.Provider
      value={{
        ...state,
        dispatch,
      }}
    >
      {children}
    </CategoryContext.Provider>
  )
}

export default CategoryContext
